import React, { useEffect, useState } from 'react'


const RandomPingCirlces = () =>{

    const [pos1, setPos1] = useState({top:50, left:0});
    const [pos2, setPos2] = useState({top: 50, left: 100 });

    const randomPos = () => ({
      top: Math.random() * 80 + 10,
      left: Math.random() * 80 + 10,
    });
    
    useEffect(() => {
      const interval = setInterval(() => {
      setPos1(randomPos());
      setPos2(randomPos());
    },3000);

    return () => clearInterval(interval);

  }, []);
  
  return (
    <div className="relative w-full h-screen bg-none">
      <div
        className="absolute w-16 h-16 rounded-full border-4 border-blue-400 animate-pingSlow"
        style={{
          top: `${pos1.top}%`,
          left: `${pos1.left}%`,
          transform: 'translate(-50%, -50%)',
        }}
      />
      <div
        className="absolute w-16 h-16 rounded-full border-4 border-pink-400 animate-pingSlow delay-400"
        style={{
          top: `${pos2.top}%`,
          left: `${pos2.left}%`,
          transform: 'translate(-50%, -50%)',
        }}
      />
    </div>
  );
};

export default RandomPingCirlces
